<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <PmNoRealReportLeftTree ></PmNoRealReportLeftTree>
    </template>
    <template v-slot:right_view>
      <PmNoRealReportRightContent></PmNoRealReportRightContent>
    </template>
  </BasicLayout>
</template>

<script>
  import BasicLayout from "../../../layouts/BasicLayout";
  import PmNoRealReportLeftTree
    from "../../../components/pmConfig/pproject/PmReportManagementForP/Left/PmNoRealReportLeftTree";
  import PmNoRealReportRightContent
    from "../../../components/pmConfig/pproject/PmReportManagementForP/Right/PmNoRealReportRightContent";

  export default {
    name: "PmReportManagementForP",
    components: {
      BasicLayout,
      PmNoRealReportLeftTree,
      PmNoRealReportRightContent
    },
    data() {
      return {
        left: {
          show: true,
          name: this.$t('Pm.pmReportManagement')
        },
        middle: {
          show: false,
          name: ''
        },
        right: {
          show: true,
          crumb: `${this.$t('Pm.pmManagement')}/${this.$t('Pm.cycleMeasurement')}/${this.$t('Pm.pmReportManagement')}`
        }
      }
    },
  }
</script>

<style scoped>

</style>
